module.exports = __webpack_public_path__ + "img/mrae.53eeda32.png";